/**
 * @generated SignedSource<<9709dc52c3f3ce8722b1b35f0c3770aa>>
 * @relayHash b7945bef1372e351545696b876fc2ee3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 77d91f27d94a67bb5f655982c2afe06650ac9257665cc9d75d29eaf51f4db812

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiNotificationLogsPageQuery } from './uiNotificationLogsPageQuery.graphql';

const node: PreloadableConcreteRequest<uiNotificationLogsPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "77d91f27d94a67bb5f655982c2afe06650ac9257665cc9d75d29eaf51f4db812",
    "metadata": {},
    "name": "uiNotificationLogsPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
